// extracted by mini-css-extract-plugin
export default {"container":"style_container__52tpe","text":"style_text__KRN4+","icon":"style_icon__G2HPi"};